import React from "react";
import Tabs, { Tab } from "../Tabs";

interface PatientsTabsProps {
  activeTab: 1 | 2 | 3;
  onTabChange: (tab: 1 | 2 | 3) => void;
}

const DASHBOARD_TABS: Tab<1 | 2 | 3>[] = [
  { id: 1, label: "AI Plans Awaiting Review" },
  { id: 2, label: "Approved Treatment Plans" },
  { id: 3, label: "Accepted by Patient" },
];

const PatientsTabs: React.FC<PatientsTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <Tabs<1 | 2 | 3>
      tabs={DASHBOARD_TABS}
      activeTab={activeTab}
      onTabChange={onTabChange}
    />
  );
};

export default React.memo(PatientsTabs);
